import ScrollStick from '../util/scroll-stick';
import { getViewportSizeName } from '../util/general-util';
import ModalTeam from '../components/modal-team';

class SinglePost {
    constructor(el) {
        this.el = el;

        this.bottomStopEl = document.querySelector('.tmpl-post-single');
        this.shareStickyEl = this.el.querySelector('.tmpl-post-single__share-icons');

        this.lastViewportSizeName = getViewportSizeName();

        this.initSticky();

        this.initializeModals();

        window.addEventListener('resize', () => {
            const viewportSizeName = getViewportSizeName();

            if (this.lastViewportSizeName !== viewportSizeName) {
                this.lastViewportSizeName = viewportSizeName;

                this.initSticky();
            }
        });
    }

    getStickyTopSpacing() {
        return this.lastViewportSizeName === 'large' ? 100 : 80;
    }

    initSticky() {
        if (this.getViewportSizeName === 'small') {
            if (this.sidebarSticky) {
                this.sidebarSticky.disable();
            }

            return;
        }

        if (this.sidebarSticky) {
            this.sidebarSticky.setTopTriggerOffset(this.getStickyTopSpacing());
            this.sidebarSticky.enable();
        } else {
            this.sidebarSticky = new ScrollStick(this.shareStickyEl, this.getStickyTopSpacing());
        }
    }

    initializeModals = () => {
        const teamMemberWrappers = this.el.querySelectorAll('.author-info');

        teamMemberWrappers.forEach(t => {
            const btnModalTeam = t.querySelector('.js__team-modal');
            const modalTeam = t.querySelector('.block-team-modal').innerHTML;
            if (btnModalTeam) {
                btnModalTeam.addEventListener('click', () => {
                    ModalTeam.show(
                        modalTeam
                    );
                });
            }
        })

    };
}

export default SinglePost;
